export default __webpack_public_path__ + "static/0107-c8e9661c40ca3da932fbcee98215e45f.png";